import Production from "./production";
import Reporting from "./reporting";
import Projections from "./projections";

export default [...Production, ...Reporting, ...Projections];
